// Links are built as `${base}/${quoteId}/...`, and Azure Storage treats a doubled
// slash as part of the blob name, so a trailing slash in the configured base URL
// makes every download link return 404.
const quotesBaseUrl = function quotesBaseUrl(): string {
  return window.AutoQuotes.config.quotesBaseUrl.replace(/\/+$/, '');
};

export default quotesBaseUrl;
